import React, { Component } from 'react'
import { Card, Row, Col, Modal, message } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import { ShelterConsumer, ShelterProvider } from '../../context/ShelterContext'
import { QuestionGroupProvider } from '../../context/QuestionGroupContext'
import { LanguageProvider } from '../../context/LanguageContext'
import { InvoiceConsumer, InvoiceProvider } from 'context/InvoiceContext'
import debounce from 'lodash.debounce'
import InvoiceList from 'components/InvoiceList'
import { InfoCircleOutlined } from '@ant-design/icons'

export default class Invoices extends Component {
   ref:any

  private questionDispatchOptions = {
    search: {
      payout_status_key: 'UNPAID',
    },
    options: {
      sort: []
    }
  } as const

  renderAdd = () => {

    return null
  }

  componentDidMount(): void {
    this.ref =  React.createRef();
  }

  

  render() {
    const { permissions, history }: any = this.props

    return (
      <InvoiceProvider>
        <QuestionGroupProvider>
          <LanguageProvider>
            <ShelterProvider>
            <ShelterConsumer>
            {({ shelters, requestShelterList }) => (
              <InvoiceConsumer>
                {(invoiceContext) => {

                  const loadSheltersDispatch = (args: any = {}) =>
                    requestShelterList({
                      search: {
                        ...args,
                        organization_branches: {
                          with: true,
                        },
                      },
                      options: {
                        limit:-1,
                        sort: ["-organization_branches.name"],
                        _force_ids: true,
                      },
                    });

                  const delayedSearch = debounce((v) => {
                    if (v) {
                      loadSheltersDispatch({ name: { ilike: `%${v}%` } });
                    }
                  }, 500);

                  const sheltersToFilter = shelters?.map((v) => {
                    return {
                      value: v.id,
                      text: v.name,
                    };
                  });

                  const handleCycleSetPaid = (uuid: string, amount: number) => {

                    Modal.confirm({
                      title: `Are you sure you want to set this cycle as paid for $${amount}?`,
                      icon: <InfoCircleOutlined />,
                      content: <></>,
                      onOk: () => {
                        return invoiceContext.requestInvoiceSetPaid({
                          cycle_uuid: uuid,
                        })
                          .then(() => {
                            message.success("Cycle set as paid successfully!");
                          })
                          .catch((error) => {
                            message.error(
                              `Could not set the cycle as paid. Reason: ${error}`,
                              7
                            );
                          });
                      },
                    });
                  };

                  /*const SKIPPED;
                      const FORECAST;
                      const TRANSFERRED;
                      const PAID;
                      const UNPAID;
                      const SETTLED;
                      const COVERAGE;
                      const CREDIT;*/

                    const invoicesStatus = [
                      'UNPAID',
                      'SKIPPED',
                      'FORECAST',
                      'TRANSFERRED',
                      'PAID',
                      'SETTLED',
                      'COVERAGE',
                      'CREDIT',
                    ]

                    const groupsToFilter = invoicesStatus.map(invoice => {
                      return {
                        value: invoice,
                        text: invoice
                      }
                    })

                    return (
                      <>
                        <Card title="Filters" style={{marginBottom: 25}}>
                          <Filters ref={this.ref} size="medium" loading={invoiceContext.fetching} history={history} defaultSubmitOptions={this.questionDispatchOptions} submitDispatch={invoiceContext.requestInvoiceList} >
                            {({ values, handleFilterChange }: any) => (
                              <Row gutter={9} style={{width: '100%'}}>
                                <Col xs={24} md={8}>
                                  <FilterItem
                                    name="payout_status_key"
                                    loading={!!invoiceContext.fetching}
                                    type={Types.SELECT}
                                    placeholder="Filter by Status"
                                    data={groupsToFilter as any || []}
                                    value={values['payout_status_key']}
                                    defaultValue='UNPAID'
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true
                                      }
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>

                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="shelter_id"
                                    type={Types.SELECT}
                                    placeholder="Shelter"
                                    data={sheltersToFilter}
                                    value={values["shelter_id"]}
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true,
                                        onDropdownVisibleChange: (open) => {
                                          if (open) {
                                            loadSheltersDispatch();
                                          }
                                        },
                                        onSearch: async (v) => {
                                          delayedSearch(v);
                                        },
                                      },
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Filters>
                        </Card>
                        <Card title="List of Invoices" extra={this.renderAdd()}>
                          <InvoiceList
                            loading={invoiceContext.fetching}
                            permissions={permissions} 
                            history={history}
                            invoices={invoiceContext.invoices}
                            pagination={invoiceContext.pagination}
                            defaultSubmitOptions={invoiceContext.filters}
                            loadInvoices={invoiceContext.requestInvoiceList}
                            handleCycleSetPaid={handleCycleSetPaid}
                          />
                        </Card>
                      </>
                    )
                }}
              </InvoiceConsumer>
            )}
            </ShelterConsumer>
            </ShelterProvider>
          </LanguageProvider>
        </QuestionGroupProvider>
      </InvoiceProvider>
    )
  }
}
